export default function Course__CourseUrl(course, baseUrl = "") {
  if (course.category && course.subcategory) {
    return `${baseUrl}/classes/${course.category}/${course.subcategory}/${course.slug}`;
  }
  return "";
}
